import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { SECURITY_API } from "./apiRoutes";

const mutateVerifyOtp = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${SECURITY_API}/verify-otp`, data);
};

const useVerifyOtpMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateVerifyOtp,
    ...queryParams,
  });

export default useVerifyOtpMutation;
